import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { InvoicePaymentTermValueSchema } from '../billing/invoice-payment-term-values.ts'
import { PaymentGatewaySchema } from '../billing/payment-gateway.ts'
import {
  BillingServiceIdSchema,
  BillingServiceMethodIdSchema,
} from '../billing-service.models.ts'
import { TipaltiIdSchema } from '../payment/tipalti-id.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'
import { DisplayIdSchema } from './display-id.ts'
import { TransactionKindSchema } from './transaction-kind.ts'
import { UbsAgreementIdSchema } from './ubs-agreement-id.ts'
import { UbsEntityIdSchema } from './ubs-entity-id.ts'
import { UbsInvoiceIdSchema } from './ubs-invoice-id.ts'
import { UbsInvoiceStatusSchema } from './ubs-invoice-status.ts'

export const UbsInvoiceSchema = z.object({
  invoiceId: UbsInvoiceIdSchema,
  agreementId: UbsAgreementIdSchema,
  transactionKind: TransactionKindSchema,
  displayId: DisplayIdSchema,
  projectId: ProjectIdSchema.optional(),
  ubsEntityId: UbsEntityIdSchema.optional(),
  amount: z.number(),
  status: UbsInvoiceStatusSchema,
  paymentTerm: InvoicePaymentTermValueSchema.optional(),
  issueDate: DateStringSchema,
  dueDate: DateStringSchema,
  tipaltiId: TipaltiIdSchema.optional(),
  stripeId: BillingServiceIdSchema.optional(),
  stripePaymentMethodId: BillingServiceMethodIdSchema.optional(),
  paymentGateway: PaymentGatewaySchema.optional(),
  metadata: z.record(z.string(), z.any()).optional(),
})

export type UbsInvoice = ZodInfer<typeof UbsInvoiceSchema>
